import { render, staticRenderFns } from "./AffinityOrder.vue?vue&type=template&id=602910ce"
import script from "./AffinityOrder.vue?vue&type=script&lang=js"
export * from "./AffinityOrder.vue?vue&type=script&lang=js"
import style0 from "./AffinityOrder.vue?vue&type=style&index=0&id=602910ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports